// import boardImg from '../../images/services/board.jpg';
import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const BoardGovernanceSupport = () => {
  const serviceData = {
    title: "Board & Shareholder Governance Support",
    heading: "Board & Shareholder Governance Support",
    image: subTopicImages["Board & Shareholder Governance Support"],
    intro: "Strengthening Board, Governance & Decision-Making Processes",
    description: [
      "The Board of Directors carries primary legal and fiduciary responsibility for the company. Effective governance requires strong meeting processes, structured approvals, accurate minutes, and transparent reporting.",
      "Weak governance exposes organisations to regulatory notices, legal challenge, investor concern, and reputational risk.",
      "We support companies in building a disciplined and compliant Board governance environment.",
    ],
    services: [
      {
        title: "Governance Support Services",
        text: "Our services include:",
        list: [
          "drafting Board & Committee notices, agendas & papers",
          "preparing minutes and resolutions",
          "documenting AGM and EGM proceedings",
          "advisory on directors’ duties & responsibilities",
          "designing governance policies and processes",
          "implementing best-practice Board controls",
          "supporting shareholder meetings and voting",
          "record-keeping & statutory governance registers",
        ],
        extraInfo: "",
      },
    ],
    benefitsIntro: "Our governance philosophy",
    benefits: [
      "transparent",
      "well-documented",
      "Board-driven",
      "regulator-aligned",
    ],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default BoardGovernanceSupport;
